document.addEventListener('DOMContentLoaded', () => {
  // Check for lightbox triggers on the page
  const lightboxTriggers = document.querySelectorAll('.lightbox-trigger');

  // Only initialize lightbox functionality if triggers are present
  if (lightboxTriggers.length > 0) {
      const lightboxOverlay = document.getElementById('lightboxOverlay');
      const lightboxImage = document.getElementById('lightboxImage');
      const body = document.body;

      // Function to show the lightbox with the selected image
      const showLightbox = (imageUrl) => {
          lightboxImage.src = imageUrl;
          lightboxOverlay.classList.remove('hidden');
          lightboxOverlay.classList.add('flex');
          // Disable body scroll
          body.style.overflow = 'hidden';
      };

      // Function to hide the lightbox
      const hideLightbox = () => {
          lightboxOverlay.classList.add('hidden');
          lightboxOverlay.classList.remove('flex');
          // Enable body scroll
          body.style.overflow = '';
      };

      // Close the lightbox when the Escape key is pressed
      const handleEscape = (event) => {
          if (event.key === 'Escape') {
              hideLightbox();
          }
      };

      // Attach click event to all lightbox triggers
      lightboxTriggers.forEach(trigger => {
          trigger.addEventListener('click', (event) => {
              event.preventDefault();
              const target = event.currentTarget.getAttribute('data-target');
              showLightbox(target);
          });
      });

      // Create a close button for the lightbox
      const closeButton = document.createElement('button');
      closeButton.innerText = '×'; // '×' is a multiplication sign, often used as a close button
      closeButton.classList.add('absolute', 'top-1', 'right-5', 'text-white', 'text-3xl');

      // Function to enhance the hideLightbox logic
      const enhancedHideLightbox = () => {
          hideLightbox();
          // Remove the keydown event listener when lightbox is closed
          document.removeEventListener('keydown', handleEscape);
      };

      // Attach click event to the lightbox overlay to close it
      lightboxOverlay.addEventListener('click', (event) => {
          if (event.target === lightboxOverlay || event.target === closeButton) {
              enhancedHideLightbox();
          }
      });

      // Listen for the Escape key to close the lightbox
      document.addEventListener('keydown', handleEscape);

      // Set the close button to hide the lightbox when clicked
      closeButton.onclick = enhancedHideLightbox;

      // Append close button to the overlay
      lightboxOverlay.appendChild(closeButton);
  }
});
